module.exports = __webpack_public_path__ + "static/media/image_file.c4ee39be.svg";